import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import moment from 'moment-timezone';
import { Typography, Box, Grid, Button } from '@mui/material';
import { AttachIcon, CircleFilledIcon } from 'components/elements/Icons';
import { useTranslation } from 'react-i18next';
import { invoiceStatus } from 'const';
import { useFetchInvoiceStripe } from 'hooks';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function AppointmentInvoices({ invoices, id }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  const { getLink, download } = useFetchInvoiceStripe();

  const stripePay = (invoiceId) => {
    getLink(invoiceId);
  };

  return (
    <Box className={classes.appointmentInvoices} data-testid="appointment-invoices">
      <div className={classes.attachmentsHeader}>
        <div className={classes.attachmentsHeaderTitleWrapper}>
          <Typography className={classes.healthcareServiceName} variant="h5" color="text" component="h3" noWrap data-aptid={id}>
            {t('invoices')}
          </Typography>
        </div>
      </div>
      <div className={classes.attachmentsWrapper}>
        {invoices.length ? (
          <Box>
            {invoices.map((row) => (
              <Box key={row.name} sx={{ '&:last-child': { borderBottomWidth: 0 } }} className={classes.invoiceBox}>
                <Grid container spacing={2}>
                  <Grid item xs={1} onClick={() => download(row.id)} className={classes.linkToAttachment}>
                    <AttachIcon />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="p" color="text" component="p" noWrap>
                      {t('invoice_no')}: {row.invoiceNumber}
                    </Typography>
                    <Typography variant="p" color="text" component="p" noWrap title={row.paidDate && moment(row.paidDate).format('llll')}>
                      {t('date_paid')}: {row.paidDate && moment(row.paidDate).format('llll')}
                    </Typography>
                  </Grid>
                  <Grid item xs={7} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    {row.paymentMode === 'stripe' && row.status === 'unpaid' && (
                      <Button variant="contained" href="#contained-buttons" size="small" onClick={() => stripePay(row.id)} className={classes.payHere}>
                        {t('pay_here')}
                      </Button>
                    )}
                    <Typography component="p" variant="p" className={classes.status}>
                      <CircleFilledIcon classes={classes[`circleIcon${invoiceStatus.statusColor[row.status]}`]} />
                      {t(`${row.status}`)}
                    </Typography>
                    <Typography component="p" variant="p" className={classes.status}>
                      {moment(row.createdAt).format('ll')}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Box>
        ) : (
          <div className={classes.noInvoices}>
            <Typography variant="body1" color="textSecondary" component="p">
              {t('no_invoices_available')}
            </Typography>
          </div>
        )}
      </div>
    </Box>
  );
}

AppointmentInvoices.propTypes = {
  invoices: PropTypes.arrayOf(PropTypes.object).isRequired,
  id: PropTypes.string.isRequired,
};

export default AppointmentInvoices;
